var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 .864h24.738M1 7.864h24.738M1 14.864h24.738",
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
})));
export default SvgMenuIcon;